import {
	createResource,
	useResource,
	type ResourceStoreContext,
	type RouterDataContext,
	type RouteResource,
} from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import {
	RESOURCE_ASSETS_USER_PERMISSION,
	ASSETS_USER_PERMISSION_KEY,
	emptyAssetsPermissionResponse,
} from './emptyAssetsPermissionResponse.constants.tsx';
import checkAssetsPermission from './checkAssetsPermission.tsx';
import type { AssetsPermissionResponse } from './AssetsPermissionResponse.types.tsx';

export const assetsUserPermissionResource: RouteResource<AssetsPermissionResponse> =
	createResource<AssetsPermissionResponse>({
		type: RESOURCE_ASSETS_USER_PERMISSION,
		getKey: () => ASSETS_USER_PERMISSION_KEY,
		getData: async (
			_routerContext: RouterDataContext,
			customContext: ResourceStoreContext,
		): Promise<AssetsPermissionResponse> => {
			if (!fg('aurum-997-license-kill-switch')) {
				return emptyAssetsPermissionResponse;
			}

			return checkAssetsPermission(customContext);
		},
		maxAge: __SERVER__ ? 0 : Number.MAX_SAFE_INTEGER,
		isCritical: true,
	});

export const useAssetsUserPermission = (): AssetsPermissionResponse => {
	const { data } = useResource<AssetsPermissionResponse>(assetsUserPermissionResource);
	return data ?? emptyAssetsPermissionResponse;
};

export const useAssetsUserPermissionLoading = (): boolean => {
	const { loading } = useResource<AssetsPermissionResponse>(assetsUserPermissionResource);
	return loading ?? false;
};
